import axios from 'axios';//引入axios
// import md5 from 'js-md5';
//正式
// var baseURL = 'http://www.haiturn.com/DPService/DFService.asmx/';
// var baseURL = 'http://www.haiturn.com/DPService/DFService.asmx/';
var baseURL = 'http://www.haiturn.com/DPService/DFService.asmx/';
//配置请求的根路径
axios.defaults.baseURL = baseURL;
// 请求超时时间
axios.defaults.timeout = 38000;
// // 请求拦截器,将header都加上token
// axios.interceptors.request.use(config => {
//     // console.log(config)
//     // config.headers.token = window.sessionStorage.getItem("token")
//     //在最后必须 return config
//     return config
// })

//响应拦截器
axios.interceptors.response.use(
    response => {
        //如果返回的状态码为200，说明接口请求成功
        //否则抛出错误
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        // debugger;
        if (error.response.status) {
            switch (error.response.status) {
                case 404:
                    //请求不存在
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    // Toast({
                    //     message: error.response.data.message,
                    //     duration: 1500,
                    //     forbidClick: true
                    // });
                    break;
            }
            return Promise.reject(error.response);
        }
    }
)

/**
 * get方法
 * @param {String} url  url地址
 * @param {Object} params 参数
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        // let CliqueID = window.sessionStorage["CliqueID"];
        // let OperUserID = window.sessionStorage["UserID"];
        // let Authority = window.sessionStorage["authority"];
        // let defaultparam = {
        //     CliqueID, OperUserID, Authority
        // }
        // Object.assign(defaultparam, params);
        axios.get(url, { params: params }).then(res => {
            // resolve(JSON.parse(res.data));
            resolve(res.data);
        }).catch(err => {
            reject(res.data)
        })
    })
}

/**
 * post方法
 * @param {String} url url地址
 * @param {Object} params 参数
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        let param = new URLSearchParams();
        param.append("data", JSON.stringify(params));
        axios.post(url, param, { headers: { 'content-type': 'application/x-www-form-urlencoded' } }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

// /**
//  * post方法获取token
//  * @param {String} url url地址
//  * @param {Object} params 参数
//  */
// export function post_token(url, params) {
//     return new Promise((resolve, reject) => {
//         let str = JSON.stringify({ "expires": 3600000 });
//         let time = Date.now();
//         let sign = md5(str + time + 'sedAPExR5keAHx6Aae56W8pd');
//         // console.log(str + time + 'sedAPExR5keAHx6Aae56W8pd', sign);
//         axios.post(url, params, {
//             headers: {
//                 'Content-Type': 'application/json; charset=utf-8',
//                 'X-Client-Id': 'AkmMkwRi8w3wPHss',
//                 'X-Timestamp': time,
//                 'X-Sign': sign,
//             }
//         }).then(res => {
//             resolve(res.data);
//         }).catch(err => {
//             reject(err, err.data);
//         })
//     })
// }

/**
 * post方法
 * @param {String} url url地址
 * @param {Object} params 参数
 */
export function post_appoint(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params, { headers: { 'Content-Type': 'application/json; charset=utf-8' } }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data);
        })
    })
}

/**
 * post文件方法
 * @param {String} url url地址
 * @param {Object} params 参数
 */
export function postfile(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params).then(res => {
            resolve(JSON.parse(res.data));
        }).catch(err => {
            reject(err.data);
        })
    })
}

export default {
    baseURL,
}


// WEBPACK FOOTER //
// ./src/api/service.js